import { TSAInstitutionListItem, TSAInstitutionListItems } from '@sim-admin-frontends/data-access';
import { Table, TExtendedColumn } from '@sim-admin-frontends/ui-shared';
import { FC } from 'react';

export interface InstitutionsViewProps {
  data: TSAInstitutionListItems;
  columns: TExtendedColumn<TSAInstitutionListItem>[];
  onNextPress: () => void;
  onPreviousPress: () => void;
  pageIndex: number;
  itemsCount: number;
  loading: boolean;
  hasNextPage: boolean;
  tablePageSize: number;
}

const InstitutionsView: FC<InstitutionsViewProps> = ({
  data,
  columns,
  onNextPress,
  pageIndex,
  onPreviousPress,
  itemsCount,
  loading,
  hasNextPage,
  tablePageSize,
}) => {
  return (
    <Table
      tablePageSize={tablePageSize}
      loading={loading}
      itemsCount={itemsCount}
      pageIndex={pageIndex}
      data={data}
      columns={columns}
      hasPagination={true}
      onNextPress={onNextPress}
      hasNextPage={hasNextPage}
      onPreviousPress={onPreviousPress}
      noRightPadding
      testId="InstitutionsView#Table"
      responsive
    />
  );
};

export { InstitutionsView };
